var theToggle = window.document.querySelector('.toggle-btn__label')
theToggle.addEventListener("click", function(){
	var thePersonalizeArea = window.document.querySelector('.product-form__personalize-content')
	if(!thePersonalizeArea.classList.contains('visible')){
		//console.log("personalize is visible")
	}else{
		//console.log("personalize is not visible")
		var pLine = window.document.querySelector('.product-form__personalize-input')
		pLine.value = ''
	}    
});

